import React, { useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import ContextMenu, { ViewGroupOptions } from "./ContextMenu";
import OutsideAlerter from "@shared/Components/Utils/OutsideAlerter";

interface SettingButtonProps {
	setViewGroups: React.Dispatch<React.SetStateAction<ViewGroupOptions[]>>;
	viewGroups: ViewGroupOptions[];
}

export default function SettingButton(props: SettingButtonProps) {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<OutsideAlerter onClick={() => setIsOpen(false)}>
				<div
					className={
						"flex cursor-pointer items-center rounded-md border border-transparent    transition-colors hover:bg-gray-100 active:bg-gray-100 p-1  " +
						(isOpen ? "bg-gray-100 hover:bg-gray-100" : "")
					}
					onClick={() => setIsOpen((prevState) => !prevState)}
				>
					<BsThreeDotsVertical size={19} color={"rgb(75 85 99)"} />
				</div>
				<ContextMenu
					isOpen={isOpen}
					viewGroups={props.viewGroups}
					setViewGroups={props.setViewGroups}
				></ContextMenu>
			</OutsideAlerter>
		</>
	);
}
